import {
  SAVE_LOGIN,
  INCREMENT,
  LOGIN_STATE
} from './mutation-types'


export default {
  [INCREMENT](state) {
    state.count++
  },
  [SAVE_LOGIN](state, payload) {
    state.loginInfo = payload
  },
  [LOGIN_STATE](state, payload) {
    state.loginInfo = payload // 储存用户登录信息
    localStorage.setItem(LOGIN_STATE, JSON.stringify(payload)) // 存入localStorage中
  },
}



// WEBPACK FOOTER //
// ./src/store/mutations.js